import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { UserService } from './user.service';

export interface Acuerdos {
  idFamilia:      string;
  nombre:         string;
  total_acuerdos: string;
  acuerdos:       Acuerdo[];
}

export interface Acuerdo {
  id:                       string;
  label:                    string;
  desglose:                 Desglose[];
  activo:                   string;
  creado:                   string;
  total_aportacion:         string;
  total_unidades_articulos: string;
  total_unidades_acuerdo:   string;
  dias_restantes:           string;
}

export interface Desglose {
  id:                        string;
  relPack:                   string;
  Nombre:                    string;
  aportacion:                string;
  creado:                    string;
  input:                     string;
  historial:                 HistorialElement[] | boolean;
  acuerdo_unidades_original: string;
  tpv5_total_comprado:       string;
  valores_total:             string;
  total_valores_tpv:         string;
}

export interface HistorialElement {
  id:       string;
  unidades: string;
  creado:   string;
  activo: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AcuerdosService {

  public loading: boolean = false;
  public acuerdos: Acuerdos[] = [];
  public proveedores: any[] = [];

  constructor(
    public rest: RestService,
    public user: UserService) {}

  GetData() {
    this.loading = true;
    this.user.loading = true;
    this.rest.GetDatos()
    .subscribe( (data) => {
      this.acuerdos = data['data'];
      this.loading = false;
      this.user.loading = false;
    });
  }

  GetFamilias() {
    this.rest.getProveedores().subscribe ((data) => {
      this.proveedores = data['data'];
    }, (error) => this.proveedores = [] );
  }
}
